export default __webpack_public_path__ + "static/media/under-construction.8745adb3.jpg";